import API from '@/API/API'

const AdminListingsStore = {
  api: API,
  state: {
    currentUserId: '',
    listings: []
  },
  getListings: function(success,error,maintenance){
    let self = this;
    this.api
    .getAdminListings()
    .then(function (res) {
      
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            self.state.listings = data.listings;
            success(data);
        }
      }else{
          error("Failed to get listings");
      }
    })
    .catch(e => {
      
      error('An Error Occurred')
    })
  },
  removeListing: function(id,success,error,maintenance){
    let self = this;
    this.api
    .removeListing(id)
    .then(function (res) {
      
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            success();
        }
      }else{
          error("Failed to remove listing");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  }
}

export default AdminListingsStore



// WEBPACK FOOTER //
// ./src/components/admin/AdminListingsStore.js